export type BpsPosition = 'links' | 'rechts';
export type BpsMesswertAnzeige = 'analog' | 'digital' | undefined;

export enum BpsArt {
  Rolle = 'rolle',
  Platte = 'platte'
}

export interface IBpsReferenzkraftMesswerte {
  messbereich: number;
  objekt: string;
}

interface IBpsReferenzkraftMesswertePunkt {
  anzeige: number;
  fehlergrenze: number;
}

export interface IBpsReferenzkraftPlattensatzMesswert {
  bps: number | null;
  sensor: number | null;
  referenzwert: number | null;
  messwertabweichung: number | null;
}

interface IBpsReferenzkraftBeurteilungRequestMesspunkt {
  messwerte: (number | null)[];
  fehlergrenze: number | null;
  messunsicherheit: number | null;
  abweichung: number | null;
}
export interface IBpsReferenzkraftBeurteilungRequest {
  mittelwerte: {
    links?: number | null;
    rechts?: number | null;
  };
  position: string;
  messbereich: string | undefined;
  messbereiche: {
    klein?: number;
    gross?: number;
  };
  messwerte: IBpsReferenzkraftBeurteilungRequestMesspunkt[];
  objekt: string;
  kmg: string;
}

export interface IBpsReferenzkraftBeurteilungPunkt {
  risiko: number | null;
  bewertung: boolean | null;
}

export interface IBpsReferenzkraftGesamtMesspunkt {
  kraftstufe: number;
  links: number;
  rechts: number;
  absolut: number;
  relativ: number | null;
  bewertung: boolean;
}

/** Interfaces für Prüfortparameter */
export interface IBpsReferenzkraftPruefortParameterKomponente {
  wert: number | null;
  min: number;
  max: number;
}

export interface IBpsReferenzkraftWaegezelle {
  messwerte: Array<number | undefined>;
  sollwert: number;
  toleranz: number;
}

export interface IBpsReferenzkraftPruefortParameter {
  lufttemperatur: IBpsReferenzkraftPruefortParameterKomponente;
}

export interface IBpsReferenzkraftRollensatzVorbelastungMesspunkt {
  anzeige: number | null;
  normal: number | null;
}

export interface IBpsReferenzkraftRollensatzVorbelastung {
  messpunkte: IBpsReferenzkraftRollensatzVorbelastungMesspunkt[];
}

export interface IBpsReferenzkraftPlattensatzMesspunkt {
  anzeige: number;
  messwerte: Array<IBpsReferenzkraftPlattensatzMesswert>;
  mittelwert: number | undefined;
  mittelwertabweichung: number | null;
  messunsicherheit: number | null;
  beurteilung: boolean | null;
}

export interface IBpsReferenzkraftPlattensatz {
  position: BpsPosition;
  messpunkte: IBpsReferenzkraftPlattensatzMesspunkt[];
  vorbelastung: IBpsReferenzkraftRollensatzVorbelastung;
}

export interface IBpsReferenzKraftGesamtErgebnis extends Array<IBpsReferenzkraftGesamtMesspunkt> {}

/** Interface mit allen Daten zur Messwerteingabe- und Berechnung für die Beurteilung der BPS Platte */
export interface IBpsReferenzkraftMessungPlatte {
  version: number | null;
  richtlinie: string;
  messbereich: number | undefined;
  anzeige: BpsMesswertAnzeige;
  justageInfo: string;
  plattensatz: {
    links: IBpsReferenzkraftPlattensatz;
    rechts: IBpsReferenzkraftPlattensatz;
  };
  plattensatzJustage: {
    links: IBpsReferenzkraftPlattensatz;
    rechts: IBpsReferenzkraftPlattensatz;
    gesamtErgebnis: IBpsReferenzKraftGesamtErgebnis;
  };
  pruefortparameter: {
    beginn: IBpsReferenzkraftPruefortParameter;
    ende: IBpsReferenzkraftPruefortParameter;
  };
  gesamtErgebnis: IBpsReferenzKraftGesamtErgebnis;
  waegezelle: IBpsReferenzkraftWaegezelle;
  kmg: string;
  objekt: string;
}

/** Interfaces für Back-End Kommunikation */
export interface IBpsReferenzkraftBeurteilungResponse {
  links: Array<IBpsReferenzkraftBeurteilungPunkt>;
  rechts: Array<IBpsReferenzkraftBeurteilungPunkt>;
  gesamt: Array<IBpsReferenzkraftGesamtMesspunkt>;
  justage?: {
    links: Array<IBpsReferenzkraftBeurteilungPunkt>;
    rechts: Array<IBpsReferenzkraftBeurteilungPunkt>;
    gesamt: Array<IBpsReferenzkraftGesamtMesspunkt>;
  };
}
export interface IBpsReferenzkraftMesswerteResponse extends Array<IBpsReferenzkraftMesswertePunkt> { }



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/ApiTypesBpsPlatte.ts